/**
 * 
 */
class WMUWCReviewList {

	/**
	 * 
	 * @type String
	 */
	actionQuery = '';

	/**
	 * 
	 * @type String
	 */
	ajaxUrl = '';

	/**
	 * 
	 * @type HTMLElement
	 */
	blockElement = null;

	/**
	 * 
	 * @type String
	 */
	blockSelector = '.block-product-reviews, .block-single-product-reviews';

	/**
	 * 
	 * @type NodeList
	 */
	langButtonList = null;

	/**
	 * 
	 * @type String
	 */
	langButtonSelector = '[data-clang]';

	/**
	 * 
	 * @type String
	 */
	nonce = '';

	/**
	 * 
	 * @type Number
	 */
	pageCount = 0;

	/**
	 * 
	 * @type Object
	 */
	queryArgs = {};

	/**
	 * 
	 * @type NodeList
	 */
	ratingButtonList = null;

	/**
	 * 
	 * @type String
	 */
	ratingButtonSelector = '[data-crating]';

	/**
	 * 
	 * @type HTMLElement
	 */
	reviewListElement = null;

	/**
	 * 
	 * @type String
	 */
	reviewListSelector = '.commentlist';

	/**
	 * 
	 * @type String
	 */
	reviewLoadMoreButtonSelector = '.wmuwc-more-reviews-btn';

	/**
	 * 
	 * @param {Object} args 
	 */
	constructor( args )
	{
		this.actionQuery = args.actionQuery;
		this.ajaxUrl = args.ajaxUrl;
		this.nonce = args.nonce;

		if ( args.queryArgs )
		{
			this.queryArgs = { ...this.queryArgs, ...args.queryArgs };
		}

		this.init();
	}

	/**
	 * 
	 */
	init()
	{
		this.onLangButtonClick = this.onLangButtonClick.bind( this );
		this.onRatingButtonClick = this.onRatingButtonClick.bind( this );
		this.onReviewLoadMoreButtonClick = this.onReviewLoadMoreButtonClick.bind( this );
	}

	/**
	 * 
	 */
	setup()
	{
		/**
		 * @todo Revoir pour permettre une multi-implémenation du block
		 * 		 Faire un objet WMUWCBlockReview qui gère chacun un block, sa liste etc
		 */
		this.blockElement = document.querySelector( this.blockSelector );

		if ( ! this.blockElement )
		{
			console.warn( 'No block element found' );
		}

		this.reviewListElement = document.querySelector( this.reviewListSelector );

		if ( ! this.reviewListElement )
		{
			console.warn( 'No review list element found' );
		}

		/**
		 * Load more buttons
		 */
		document.querySelectorAll( this.reviewLoadMoreButtonSelector ).forEach( ( element ) =>
		{
			if ( ! element.wmuwcReviewList )
			{
				element.wmuwcReviewList = this;
				element.addEventListener( 'click', this.onReviewLoadMoreButtonClick );
			}
		} );

		/**
		 * Lang Buttons
		 */
		this.langButtonList = document.querySelectorAll( this.langButtonSelector );
		this.langButtonList.forEach( ( element ) =>
		{
			if ( ! element.wmuwcReviewList )
			{
				element.wmuwcReviewList = this;
				element.addEventListener( 'click', this.onLangButtonClick );
			}
		} );

		/**
		 * Rating Buttons
		 */
		this.ratingButtonList = document.querySelectorAll( this.ratingButtonSelector );
		this.ratingButtonList.forEach( ( element ) =>
		{
			if ( ! element.wmuwcReviewList )
			{
				element.wmuwcReviewList = this;
				element.addEventListener( 'click', this.onRatingButtonClick );
			}
		} );
	}

	/**
	 * 
	 * @param {String} content 
	 */
	listAppend( content )
	{
		this.reviewListElement.innerHTML += content.trim();

		window.dispatchEvent( new CustomEvent( 'wmuwc/reviewListAppend', {
			detail: {
				listElement: this.reviewListElement,
			}
		} ) );
	}

	/**
	 * 
	 */
	nextPage()
	{
		/**
		 * On init à 2 car dans le système actuelle, la première page est affichée à la construction de la page
		 */
		this.queryArgs.paged = ( this.queryArgs.paged ) ? this.queryArgs.paged + 1 : 2;
		this.queryStart();
	}

	/**
	 * 
	 */
	queryStart( resetList = false )
	{
		this.blockElement.classList.add( 'loading' );

		const formData = new FormData();
		formData.append( 'action', this.actionQuery );
		formData.append( '_ajax_nonce', this.nonce );

		for ( let key in this.queryArgs )
		{
			formData.append( key, this.queryArgs[ key ] );
		}

		const fetchInit = {
			method: 'POST',
			cache: 'no-cache',
			body: formData,
		};

		fetch( this.ajaxUrl, fetchInit )
			.then( ( response ) => response.json() )
			.then( ( data ) =>
			{
				console.log( data );

				if ( data.success )
				{
					if ( data.data.content )
					{
						if ( resetList )
						{
							this.reviewListElement.innerHTML = '';
						}
						
						this.listAppend( data.data.content );
					}

					if ( data.data.pageCount )
					{
						this.updatePageCount( data.data.pageCount );
					}
				}
				else
				{

				}

				this.queryComplete();
			} );
	}

	/**
	 * 
	 */
	queryComplete()
	{
		this.blockElement.classList.remove( 'loading' );
	}
	
	/**
	 * 
	 * @param {String} lang 
	 */
	setLang( lang )
	{
		if ( lang != this.queryArgs.clang )
		{
			this.queryArgs.clang = lang;
			this.queryArgs.paged = 1;
			this.queryStart( true );

			this.langButtonList.forEach( ( element ) =>
			{
				if ( lang === element.getAttribute( 'data-clang' ) )
				{
					element.classList.add( 'selected' );
				}
				else
				{
					element.classList.remove( 'selected' );
				}
			} );
		}
	}

	/**
	 * 
	 * @param {String} order 
	 */
	setOrder( order )
	{
		if ( order != this.queryArgs.corder )
		{
			this.queryArgs.corder = order;
			this.queryArgs.paged = 1;
			this.queryStart( true );
		}
	}

	/**
	 * 
	 * @param {Number} rating 
	 */
	setRating( rating )
	{
		/**
		 * @todo Sur les filtres de notes il faudra mettre à jour les count
		 */
		if ( isNaN( rating ) )
		{
			rating = 0;
		}

		if ( rating != this.queryArgs.crating )
		{
			this.queryArgs.crating = rating;
			this.queryArgs.paged = 1;
			this.queryStart( true );

			this.ratingButtonList.forEach( ( element ) =>
			{
				const elementRating = ( element.getAttribute( 'data-crating' ) ) ? parseInt( element.getAttribute( 'data-crating' ) ) : 0;

				if ( rating === elementRating )
				{
					element.classList.add( 'selected' );
				}
				else
				{
					element.classList.remove( 'selected' );
				}
			} );

			const moduleElement = document.querySelector( '.product-reviews-module-rating-distribution' );

			if ( moduleElement )
			{
				if ( rating )
				{
					moduleElement.classList.add( 'entry-selected' );
				}
				else
				{
					moduleElement.classList.remove( 'entry-selected' );
				}
			}
		}
	}

	/**
	 * 
	 * @param {Number} pageCount 
	 */
	updatePageCount( pageCount )
	{
		this.pageCount = pageCount;

		if ( this.pageCount > 0 && this.queryArgs.paged && this.queryArgs.paged >= this.pageCount )
		{
			this.blockElement.classList.add( 'no-more-page' );
		}
		else
		{
			this.blockElement.classList.remove( 'no-more-page' );
		}
	}

	/**
	 * 
	 * @param {Event} event 
	 */
	onLangButtonClick( event )
	{
		event.preventDefault();
		const btn = ( event.target.getAttribute( 'data-clang' ) ) ? event.target : event.target.closest( '[data-clang]' );
		this.setLang( btn.getAttribute( 'data-clang' ) );
	}

	/**
	 * 
	 * @param {Event} event 
	 */
	onRatingButtonClick( event )
	{
		event.preventDefault();
		const btn = ( event.target.getAttribute( 'data-crating' ) ) ? event.target : event.target.closest( '[data-crating]' );
		const btnRating = ( btn.getAttribute( 'data-crating' ) ) ? parseInt( btn.getAttribute( 'data-crating' ) ) : 0;
		this.setRating( btnRating );
	}

	/**
	 * 
	 * @param {Event} event 
	 */
	onReviewLoadMoreButtonClick( event )
	{
		event.preventDefault();
		this.nextPage();
	}

}

export default WMUWCReviewList;